<template>
  <div class="text-main-text">
    <h1 class="hidden md:block font-bold text-2xl sm:-mt-13">Зарегистрированные команды</h1>
    <div>
      <team-filter :main-url="`${base}/event-dates?`" :route="$route">
        <div slot-scope="{linked, values}">
          <pagination :base-url="linked" :client="client" @data="itemData($event)">
            <div slot-scope="{data: teams, processing, switchPage, fetchData}">
              <spinner v-if="!isHaveData"></spinner>
              <div v-else>
              <div v-if="stat_events.length+getAllEvents.length >0">
                <div>
                  <h4 v-if="statSeria.length" class="md:hidden -mb-3">
                    Статистика прошедших игр
                  </h4>
                  <stat-seria ref="serias" v-for="(seria,idx) in statSeria" :key="seria[0].event_record_id"
                              :seria="seria"
                              :statSeria="statSeria"
                              :stat_events="stat_events"
                              :serias="serias"
                              :formCity="cityUserId"
                              :userRole="user.role"
                              :eventRecordId="seria[0].event_record_id"
                              @updateEvent="refreshStatSeria($event)" />
                  <h4 v-if="getAllEvents.length" class="md:hidden mt-10">
                    Зарегистрированные команды
                  </h4>
                  <registration-list ref="events" v-for="event in getAllEvents" :event="event" :expandedRegs ="expandedRegs"
                    :getAllEvents="getAllEvents" :key="event.uuid" :city="cityUserId" @overflow="setOverflow"
                    @updateEvent="refreshEvent($event)" @restoreOtherLines="restoreOtherLines" @expandToggle="onRegistrationExpand" :user="user"></registration-list>
                </div>
              </div>

              <p v-else
                class="md:text-4xl text-2xl text-center font-semibold text-additional-text h-half-screen flex flex-col justify-center">
                Зарегистрированных <br> команд нет

              </p>
              </div>
            </div>
          </pagination>
        </div>
      </team-filter>
    </div>

  </div>
</template>
<script>
import parse from 'date-fns/parse';
import client from '@/clients/partners';
import teamFilter from '@/helpers/pagination/filter.vue';
import pagination from '@/helpers/pagination/pagination.vue';
import RegistrationList from './registration-layout/registration-list';
import { mapActions, mapState, mapGetters } from 'vuex';
import statList from './stat-layout/stat-list';
import statSeria from './stat-layout/stat-seria';
import axios from 'axios';

export default {
  name: 'registration-home',

  components: {
    RegistrationList,
    teamFilter,
    pagination,
    statList,
    statSeria,
  },
  data() {
    return {
      events: [],
      base: process.env.VUE_APP_MP_PARTNERS_BACKEND,
      fetcher: '',
      client,
      stat_events: [],
      overflow: false,
      isHaveData: false,
      expandedRegs: [],
    };
  },
  computed: {
    ...mapState({
      cityUserId: state => state.auth.user.city_id,
      cityEvents: state => state.user.cityEvents,
      user: state => state.auth.user,
    }),
    getAllEvents() {
      const eventDates = [];
      this.stat_events = [];
      for (const i in this.events) {
        for (const j in this.events[i]) {
          if (this.events[i][j].status === 'created') {
            eventDates.push(this.events[i][j]);
          } else {
            this.stat_events.push(this.events[i][j]);
          }
        }
      }

      eventDates.sort((itemA, itemB) => {
        const a = parse(itemA.played_at);
        const b = parse(itemB.played_at);
        return a > b ? 1 : a < b ? -1 : 0;
      });
      this.stat_events.sort((itemA, itemB) => {
        const a = parse(itemA.played_at);
        const b = parse(itemB.played_at);
        return a > b ? 1 : a < b ? -1 : 0;
      });
      return eventDates.filter((item) => {
        if (this.user.role === 'editor') {
          return item;
        }
        return !item.is_created_by_editor;
      });
    },
    statSeria() {
      const result_arr = [];
      const serias = {};
      this.stat_events.map(item => serias[item.event_record_id] = '');
      const seria = Object.keys(serias);
      seria.forEach(() => result_arr.push([]));
      this.stat_events.forEach((item) => {
        const idx = seria.findIndex(sub => sub === item.event_record_id);
        if (idx && idx !== -1 || idx === 0) {
          result_arr[idx].push(item);
        }
      });
      if (result_arr.length === 0) {
        this.setPartnerWaitingStatistics(false);
      }
      return result_arr;
    },
    serias() {
      const gameSerias = {};
      for (const i in this.events) {
        for (const j in this.events[i]) {
          gameSerias[this.events[i][j].event_record_id] = 0;
        }
      }
      for (const i in this.events) {
        for (const j in this.events[i]) {
          if (this.events[i][j].event_record_id in gameSerias) {
            gameSerias[this.events[i][j].event_record_id] += 1;
          }
        }
      }
      return gameSerias;
    },
  },

  beforeDestroy() {
    sessionStorage.setItem('expandedRegs', '');
    sessionStorage.setItem('expandedRegs', JSON.stringify(this.expandedRegs));
  },

  created() {
    const expandedRegsString = sessionStorage.getItem('expandedRegs');
    if (!expandedRegsString) return;
    this.expandedRegs = JSON.parse(expandedRegsString);
  },
  methods: {
    ...mapActions(['setPartnerWaitingStatistics']),
    onRegistrationExpand(eventId) {
      const idx = this.expandedRegs.findIndex(item => item === eventId);
      if (idx < 0) {
        this.expandedRegs.push(eventId);
      } else {
        this.expandedRegs.splice(idx, 1);
      }
    },

    itemData($event) {
      this.events = $event.data;
      this.fetcher = $event.fetch;
      this.isHaveData = true;
      console.dir(this.isHaveData);
    },
    refreshEvent(event) {
      this.fetcher();
      if (this.$refs.events) {
        this.$refs.events.forEach((item) => {
          if (item.show_registration) {
            setTimeout(() => {
              item.getEventData();
            }, 1000);
          }
        });
      }
    },
    refreshStatSeria() {
      client.get('event-dates').then((data) => {
        this.events = data.data;
      });
    },
    restoreOtherLines(event) {
      this.$refs.events.forEach((item) => {
        if (item.event.uuid !== event.uuid && item.$refs) {
          item.restoreLine();
        }
      });
    },
    setOverflow(event) {
      this.overflow = event.overflow;
    },
    ...mapActions({
      selectCity: 'selectCity',
    }),
  },
};
</script>
